import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { HttpclientService } from "../../../../shared";
import { Subject } from "rxjs";
import { RoomModifyRequest } from "./room-modify-request";

@Injectable()
export class DataService_RoomSetup {
	constructor(private http: HttpClient, private httpclientService: HttpclientService) {}

	RoomSelectList(SchoolID: number) {
		var postResult$ = new Subject();
		var url = "SchoolSetup/RoomSelectList?SchoolID=" + SchoolID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	RoomInsert(parms: RoomModifyRequest) {
		var postResult$ = new Subject();
		var url = "SchoolSetup/RoomInsert";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	RoomUpdate(parms: RoomModifyRequest) {
		var postResult$ = new Subject();
		var url = "SchoolSetup/RoomUpdate";

		var promise$ = this.httpclientService.post(url, parms);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	RoomToggle(RoomID: number, Active: number) {
		var postResult$ = new Subject();
		var url = "SchoolSetup/RoomToggle?RoomID=" + RoomID + "&Active=" + Active;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}

	RoomDelete(RoomID: number) {
		var postResult$ = new Subject();
		var url = "SchoolSetup/RoomDelete?RoomID=" + RoomID;

		var promise$ = this.httpclientService.post(url, null);
		promise$.subscribe((response) => {
			postResult$.next(response);
		});
		return postResult$;
	}
}
